/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3Qvc2V0dGluZy9leHBlcnQvZ3JvdXAvZ3JvdXAuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL3BhZ2VzL2FkbWluL2ljb250YWN0L3NldHRpbmcvZXhwZXJ0L2dyb3VwL2dyb3VwLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/pages/admin/icontact/setting/expert/group/group.component.css.shim.ngstyle.ts